function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M19.115 9.03a3 3 0 013 3v3a3 3 0 01-3 3v.966c0 1.06-1.236 1.639-2.05.96l-2.312-1.926h-2.638a3 3 0 01-3-3v-3a3 3 0 013-3h7z",
  fill: "#0073FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.885 3.751a3 3 0 013 3v1h-8a4 4 0 00-4 4v4c0 1.045.4 1.996 1.056 2.708l-1.056.793c-.824.617-2 .03-2-1v-1.5a3 3 0 01-3-3v-7a3 3 0 013-3h11z",
  fill: "#0073FF"
});

var SvgChatActive = function SvgChatActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgChatActive;